import { NavigationSite } from 'types/Navigation';
import { PaginatedList } from 'types/PaginatedList';
import { useGet } from 'utils/hooks/useAPI';
import { useEffect, useState, useCallback } from 'react';
import { AuthState } from 'utils/contexts/AuthContext/AuthContextType';
import { useAuthContext } from 'utils/contexts/AuthContext';

const NAVIGATION_SITES_API = '/helios-api/navigation/sites';

export const useSitesCount = () => {
    const { authState } = useAuthContext();
    const sitesUrl = `${NAVIGATION_SITES_API}?${new URLSearchParams({
        count: '1',
    })}`;

    // Fetch the least data possible (`?count=1`) just to get total sites count.
    const [, getSites] = useGet<PaginatedList<NavigationSite>>(sitesUrl, true);

    const [siteCount, setSiteCount] = useState<number>();

    const loadSiteCount = useCallback(async () => {
        try {
            const sites = await getSites();
            setSiteCount(sites?.count);
        } catch (error) {
            setSiteCount(0);
        }
    }, [getSites]);

    useEffect(() => {
        if (authState === AuthState.AUTHENTICATED) {
            loadSiteCount();
        }
    }, [authState, loadSiteCount]);

    return siteCount;
};
